import * as types from "./types";

const clearStore = () => ({
  type: types.CLEAR_STORE
});

const clearSearch = () => ({
  type: types.CLEAR_SEARCH
});

/* Fetch agent */
const fetchingAgent = id => ({
  type: types.FETCHING_AGENT,
  payload: id
});

const fetchingAgentSuccess = data => ({
  type: types.FETCHING_AGENT_SUCCESS,
  payload: data
});

const fetchingAgentError = error => ({
  type: types.FETCHING_AGENT_ERROR,
  payload: error
});

/* Fetch agent */

/* Search agent */
const searchAgent = tin => ({
  type: types.SEARCH_AGENT,
  payload: tin
});

const searchAgentSuccess = data => ({
  type: types.SEARCH_AGENT_SUCCESS,
  payload: data
});

const searchAgentError = error => ({
  type: types.SEARCH_AGENT_ERROR,
  payload: error
});

/* Search agent */

/* Add agent */
const addAgent = data => ({
  type: types.ADD_AGENT,
  payload: data
});

const addAgentSuccess = data => ({
  type: types.ADD_AGENT_SUCCESS,
  payload: data
});

const addAgentError = error => ({
  type: types.ADD_AGENT_ERROR,
  payload: error
});

/* Add agent */

/* Add agent */
const deleteAgent = invoiceId => ({
  type: types.DELETE_AGENT,
  payload: invoiceId
});

const deleteAgentSuccess = data => ({
  type: types.DELETE_AGENT_SUCCESS,
  payload: data
});

const deleteAgentError = error => ({
  type: types.DELETE_AGENT_ERROR,
  payload: error
});

/* Add agent */

export {
  fetchingAgent,
  fetchingAgentSuccess,
  fetchingAgentError,
  clearStore,
  searchAgent,
  searchAgentError,
  searchAgentSuccess,
  clearSearch,
  addAgent,
  addAgentError,
  addAgentSuccess,
  deleteAgent,
  deleteAgentError,
  deleteAgentSuccess
};
